// extracted by mini-css-extract-plugin
export default {"text--highlight":"HighlightSpan_text--highlight__NLPZA","text--italic":"HighlightSpan_text--italic__K51N4","text--bold":"HighlightSpan_text--bold__sGCFm"};